/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyPhysicians = {
    type: 'array',
    contains: {
        type: 'CompanyPhysician',
    },
};